// extracted by mini-css-extract-plugin
export default {"value":"CustomStatsGrid_value__uXUuE","icon":"CustomStatsGrid_icon__65tM3","title":"CustomStatsGrid_title__Kw9yS"};